import {ComponentProps, forwardRef} from 'react';
import {cn} from '../../libs';

export const Textarea = forwardRef<HTMLTextAreaElement, ComponentProps<'textarea'>>(
  ({...rest}, ref) => {
    return (
      <textarea
        {...rest}
        ref={ref}
        className={cn(
          'flex min-h-[80px] w-full rounded-md border border-input-border bg-bg-secondary px-3 py-2 text-sm',
          'placeholder:text-text-muted',
          'hover:border-input-border-hover',
          'focus:border-input-border-focus',
          'disabled:bg-bg-secondary-hover',
          'disabled:text-text-disabled',
          rest.className,
        )}
      />
    );
  },
);

Textarea.displayName = 'Textarea';
